"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledBox = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledBox",
  componentId: "sc-1y4fxp5-0"
})(["box-sizing:border-box;padding:7px 8px;width:50%;"]);

exports.StyledBox = StyledBox;

var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledIcon",
  componentId: "sc-1y4fxp5-1"
})(["box-sizing:border-box;height:51px;width:100%;border:", ";border-radius:4px;background-color:#F7F7F7;display:flex;align-items:center;justify-content:center;text-align:center;opacity:", ";pointer-events:", ";&:hover{border:2px solid #C32D7B;}"], function (props) {
  return props.active ? '2px solid #C32D7B' : '1px solid #E6E6E6';
}, function (props) {
  return props.disabled ? '0.2' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
});

exports.StyledIcon = StyledIcon;